/**
 * @generated SignedSource<<4b17d440b9bff002c5093f63e63c6615>>
 * @relayHash fa29079d00f66d1ebee8e96b6f0b7879
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8f40d1de74cdbdc9f9129faa4a7553a3f9f2e5640d49a1251a758dc120481c0d

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GoalPanelQuery$variables = {
  ari: string;
};
export type GoalPanelQuery$data = {
  readonly goals_byId: {
    readonly id: string;
    readonly key: string;
    readonly url: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"GoalActions" | "GoalFocusAreas" | "GoalFollowers" | "GoalMetrics" | "GoalOwner" | "GoalPanelTitleField" | "GoalStartDate" | "GoalStatusField" | "GoalTags" | "GoalTargetDate" | "GoalTeams" | "GoalType" | "ParentGoal" | "SubGoals">;
  };
  readonly me: {
    readonly user: {
      readonly id: string;
      readonly name: string;
      readonly picture: AGG$URL;
    } | null | undefined;
  };
  readonly " $fragmentSpreads": FragmentRefs<"GoalPanelTabs">;
};
export type GoalPanelQuery = {
  response: GoalPanelQuery$data;
  variables: GoalPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ari"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "picture"
},
v4 = [
  {
    "kind": "Variable",
    "name": "goalId",
    "variableName": "ari"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "key"
},
v6 = {
  "kind": "ScalarField",
  "name": "url"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = [
  (v7/*: any*/),
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/)
],
v9 = [
  (v5/*: any*/),
  (v1/*: any*/)
],
v10 = {
  "kind": "InlineFragment",
  "selections": [
    (v1/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v11 = {
  "kind": "ScalarField",
  "name": "value"
},
v12 = [
  (v11/*: any*/)
],
v13 = {
  "kind": "InlineFragment",
  "selections": (v12/*: any*/),
  "type": "TownsquareGoalTypeCustomName"
},
v14 = {
  "kind": "ScalarField",
  "name": "defaultValue"
},
v15 = [
  (v11/*: any*/),
  {
    "kind": "ScalarField",
    "name": "score"
  }
],
v16 = {
  "kind": "ScalarField",
  "name": "isArchived"
},
v17 = {
  "concreteType": "TownsquareGoalTypeIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v5/*: any*/)
  ]
},
v18 = {
  "kind": "ScalarField",
  "name": "type"
},
v19 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "percentage"
    },
    (v18/*: any*/)
  ]
},
v20 = {
  "concreteType": "TownsquareMetricTargetConnection",
  "kind": "LinkedField",
  "name": "metricTargets",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricTarget",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "concreteType": "TownsquareMetric",
              "kind": "LinkedField",
              "name": "metric",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v2/*: any*/),
                (v18/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "subType"
                },
                {
                  "kind": "ScalarField",
                  "name": "archived"
                },
                {
                  "kind": "ScalarField",
                  "name": "externalEntityId"
                }
              ]
            },
            {
              "concreteType": "TownsquareMetricValue",
              "kind": "LinkedField",
              "name": "snapshotValue",
              "plural": false,
              "selections": [
                (v11/*: any*/),
                (v1/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "startValue"
            },
            {
              "kind": "ScalarField",
              "name": "targetValue"
            }
          ]
        }
      ]
    }
  ]
},
v21 = {
  "concreteType": "TownsquareStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": (v12/*: any*/)
},
v22 = {
  "concreteType": "TownsquareGoalType",
  "kind": "LinkedField",
  "name": "goalType",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v1/*: any*/)
  ]
},
v23 = {
  "concreteType": "TownsquareIconURIs",
  "kind": "LinkedField",
  "name": "iconUrl",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareThemeURIs",
      "kind": "LinkedField",
      "name": "roundedSquare",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "dark"
        },
        {
          "kind": "ScalarField",
          "name": "light"
        }
      ]
    }
  ]
},
v24 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v25 = {
  "kind": "ScalarField",
  "name": "description"
},
v26 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v27 = {
  "kind": "ScalarField",
  "name": "endCursor"
},
v28 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v29 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v30 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v31 = {
  "concreteType": "TownsquareCommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareCommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareComment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v7/*: any*/),
                (v2/*: any*/),
                (v29/*: any*/),
                (v3/*: any*/),
                (v1/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v30/*: any*/),
            (v28/*: any*/)
          ]
        }
      ]
    }
  ]
},
v32 = {
  "kind": "ScalarField",
  "name": "summary"
},
v33 = [
  {
    "kind": "ScalarField",
    "name": "label"
  }
],
v34 = {
  "kind": "Literal",
  "name": "first",
  "value": 200
},
v35 = [
  (v34/*: any*/)
],
v36 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v37 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v27/*: any*/),
    (v26/*: any*/)
  ]
},
v38 = [
  (v7/*: any*/),
  (v3/*: any*/),
  (v2/*: any*/),
  (v1/*: any*/)
],
v39 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v32/*: any*/),
      (v25/*: any*/),
      {
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": (v38/*: any*/)
      },
      {
        "kind": "LinkedField",
        "name": "lastEditedBy",
        "plural": false,
        "selections": (v38/*: any*/)
      },
      (v28/*: any*/),
      {
        "kind": "ScalarField",
        "name": "lastEditedDate"
      }
    ],
    "type": "TownsquareHighlight",
    "abstractKey": "__isTownsquareHighlight"
  }
],
v40 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "ari"
},
v41 = [
  (v34/*: any*/),
  (v40/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GoalPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      },
      {
        "kind": "RequiredField",
        "field": {
          "args": (v4/*: any*/),
          "concreteType": "TownsquareGoal",
          "kind": "LinkedField",
          "name": "goals_byId",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/),
            {
              "kind": "FragmentSpread",
              "name": "GoalFocusAreas"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalPanelTitleField"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalStatusField"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalType"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalOwner"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalMetrics"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalTargetDate"
            },
            {
              "kind": "FragmentSpread",
              "name": "ParentGoal"
            },
            {
              "kind": "FragmentSpread",
              "name": "SubGoals"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalTags"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalFollowers"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalStartDate"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalActions"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalTeams"
            }
          ]
        },
        "action": "THROW",
        "path": "goals_byId"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "ari",
            "variableName": "ari"
          }
        ],
        "kind": "FragmentSpread",
        "name": "GoalPanelTabs"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GoalPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": (v8/*: any*/)
          }
        ]
      },
      {
        "args": (v4/*: any*/),
        "concreteType": "TownsquareGoal",
        "kind": "LinkedField",
        "name": "goals_byId",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseConnection",
            "kind": "LinkedField",
            "name": "focusAreas",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/),
                          (v6/*: any*/),
                          {
                            "concreteType": "MercuryFocusAreaStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": (v9/*: any*/)
                          },
                          {
                            "concreteType": "MercuryFocusAreaHealth",
                            "kind": "LinkedField",
                            "name": "health",
                            "plural": false,
                            "selections": (v9/*: any*/)
                          }
                        ],
                        "type": "MercuryFocusArea"
                      },
                      (v10/*: any*/)
                    ]
                  },
                  (v1/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareGoalIcon",
            "kind": "LinkedField",
            "name": "icon",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "ScalarField",
                "name": "appearance"
              }
            ]
          },
          (v2/*: any*/),
          {
            "concreteType": "TownsquareGoalType",
            "kind": "LinkedField",
            "name": "goalType",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v13/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "messageId"
                      },
                      (v14/*: any*/)
                    ],
                    "type": "TownsquareLocalizationField"
                  }
                ]
              },
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "name": "kind"
              }
            ]
          },
          {
            "concreteType": "TownsquareStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": (v15/*: any*/)
          },
          {
            "kind": "ScalarField",
            "name": "scoringMode"
          },
          {
            "kind": "ScalarField",
            "name": "canPostUpdate"
          },
          (v16/*: any*/),
          {
            "concreteType": "TownsquareGoalType",
            "kind": "LinkedField",
            "name": "goalType",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              {
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v13/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v14/*: any*/)
                    ],
                    "type": "TownsquareLocalizationField"
                  }
                ]
              },
              (v1/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": (v8/*: any*/)
          },
          (v19/*: any*/),
          (v20/*: any*/),
          {
            "concreteType": "TownsquareGoalConnection",
            "kind": "LinkedField",
            "name": "subGoals",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v1/*: any*/),
                      (v16/*: any*/),
                      (v20/*: any*/),
                      (v6/*: any*/),
                      (v21/*: any*/),
                      (v2/*: any*/),
                      (v22/*: any*/),
                      {
                        "concreteType": "TownsquareProjectConnection",
                        "kind": "LinkedField",
                        "name": "projects",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareProjectEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareProject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  (v2/*: any*/),
                                  (v6/*: any*/),
                                  (v23/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v24/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareTargetDate",
            "kind": "LinkedField",
            "name": "targetDate",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareTargetDateRange",
                "kind": "LinkedField",
                "name": "dateRange",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "start"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "end"
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareGoal",
            "kind": "LinkedField",
            "name": "parentGoal",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v1/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v2/*: any*/),
              (v22/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareTagConnection",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareTagEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareTag",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "usageCount"
                      },
                      (v25/*: any*/)
                    ]
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v26/*: any*/),
                  (v27/*: any*/)
                ]
              },
              (v24/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareUserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "count"
              },
              {
                "concreteType": "TownsquareUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v1/*: any*/),
                      (v3/*: any*/),
                      (v2/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "startDate"
          },
          (v28/*: any*/),
          {
            "concreteType": "TownsquareGoalTeamConnection",
            "kind": "LinkedField",
            "name": "teams",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalTeamEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canRemove"
                  },
                  {
                    "concreteType": "TeamV2",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "displayName"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "smallAvatarImageUrl"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isVerified"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "profileUrl"
                      }
                    ]
                  }
                ]
              },
              (v24/*: any*/)
            ]
          },
          (v25/*: any*/),
          (v31/*: any*/),
          {
            "concreteType": "TownsquareGoalUpdateConnection",
            "kind": "LinkedField",
            "name": "updates",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalUpdate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "ari"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "missedUpdate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "updateType"
                      },
                      (v32/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v2/*: any*/),
                          (v3/*: any*/),
                          (v1/*: any*/),
                          (v29/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "newDueDate",
                        "plural": false,
                        "selections": (v33/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareGoalState",
                        "kind": "LinkedField",
                        "name": "newState",
                        "plural": false,
                        "selections": (v15/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "name": "lastEditedBy",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v29/*: any*/),
                          (v2/*: any*/),
                          (v1/*: any*/)
                        ]
                      },
                      (v28/*: any*/),
                      (v30/*: any*/),
                      (v6/*: any*/),
                      {
                        "concreteType": "TownsquareGoalState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": (v15/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "oldDueDate",
                        "plural": false,
                        "selections": (v33/*: any*/)
                      },
                      (v31/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "canEditUpdate"
          },
          {
            "args": (v35/*: any*/),
            "concreteType": "TownsquareProjectConnection",
            "kind": "LinkedField",
            "name": "projects",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/),
                      (v6/*: any*/),
                      (v23/*: any*/),
                      (v7/*: any*/)
                    ]
                  },
                  (v36/*: any*/)
                ]
              },
              (v37/*: any*/),
              (v24/*: any*/)
            ],
            "storageKey": "projects(first:200)"
          },
          {
            "args": (v35/*: any*/),
            "handle": "connection",
            "key": "GoalContentProjects_projects",
            "kind": "LinkedHandle",
            "name": "projects"
          },
          {
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareHighlightEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v1/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v39/*: any*/),
                        "type": "TownsquareLearning"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v39/*: any*/),
                        "type": "TownsquareRisk"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v39/*: any*/),
                        "type": "TownsquareDecision"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "concreteType": "TownsquareGoalCapabilities_extension",
                "kind": "LinkedField",
                "name": "capabilities_extension",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canEditTitle"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "canManageOwnership"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "canEditTargetDate"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "canEditJiraAlignProject"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "GraphStore",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "args": [
              (v40/*: any*/)
            ],
            "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
            "kind": "LinkedField",
            "name": "atlasGoalHasJiraAlignProject",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "mercuryProjectName"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "mercuryProjectUrl"
                          }
                        ],
                        "type": "JiraAlignAggProject"
                      },
                      (v10/*: any*/)
                    ]
                  },
                  (v1/*: any*/)
                ]
              },
              (v24/*: any*/),
              (v7/*: any*/)
            ]
          },
          {
            "args": (v41/*: any*/),
            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseConnection",
            "kind": "LinkedField",
            "name": "jiraEpicContributesToAtlasGoalInverse",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v5/*: any*/),
                          (v32/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "webUrl"
                          }
                        ],
                        "type": "JiraIssue"
                      },
                      (v10/*: any*/)
                    ]
                  },
                  (v36/*: any*/),
                  (v1/*: any*/)
                ]
              },
              (v37/*: any*/),
              (v24/*: any*/)
            ]
          },
          {
            "args": (v41/*: any*/),
            "filters": [
              "id"
            ],
            "handle": "connection",
            "key": "GoalContentJira_jiraEpicContributesToAtlasGoalInverse",
            "kind": "LinkedHandle",
            "name": "jiraEpicContributesToAtlasGoalInverse"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "8f40d1de74cdbdc9f9129faa4a7553a3f9f2e5640d49a1251a758dc120481c0d",
    "metadata": {},
    "name": "GoalPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f3b37283502674d9ed9c4aeada6eec70";

export default node;
